import React from "react";

interface TextAreaProps {
  label: string;
  className?: string;
  placeholder?: string;
  name: string;
  value: string;
  onChange: Function,
}

export const TextArea = ({
  label,
  placeholder,
  name,
  value,
  onChange,
  className
}: TextAreaProps) => {
  return (
    <div>
      <label
        htmlFor={name}
        className="block mb-2 text-sm font-medium text-gray-900"
      >
        {label}
      </label>
      <textarea
        id={name}
        rows={4}
        className={`block p-2.5 w-full text-base rounded-lg border border-gray-300 hover:border-red focus:border-red focus:outline-none focus:ring-0 ${ className }`}
        placeholder={placeholder || ""}
        name={name}
        value={value}
        onChange={(e) => onChange(e)}
      ></textarea>
    </div>
  );
};
